const PropTypes = require('prop-types');
// @vendor
const React = require('react');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');

const CardChangePaymentMethodErrorStep = props => {
    const { immCard } = props;
    const title = formatText('cardChangePaymentMethodError-errorTitle');
    const cardAlias = immCard.getIn(['alias', 'current']);
    const goBackButtonLabel = formatText('cardChangePaymentMethodError-backToCard', [cardAlias]).toUpperCase();
    const linkToMovements = `/myprofile/cards/${immCard.get('cardId')}/movements`;
    const goBackButton = {
        label: goBackButtonLabel,
        url: linkToMovements
    }

    return (
        <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
            <WizardError
                errorMessage={title}
                mainButton={goBackButton}>
                <section className="row">
                    <div className="col-xs-6 col-md-5">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                    </div>
                    <div className="col-xs-6 col-md-7">
                        <FormattedText
                            value="cardChangePaymentMethodError-errorMessage"
                        />
                    </div>
                </section>
            </WizardError>
        </div>
    )
};

CardChangePaymentMethodErrorStep.propTypes = {
    immCard: PropTypes.object.isRequired
};

module.exports = CardChangePaymentMethodErrorStep;